<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData" v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>

          <SelectFilter ref="selectFilter" :options="query.dimensionType==1?filterOptions1:query.dimensionType==2?filterOptions:filterOptions2" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <span style="color: red; padding-right: 30px;">提示：红色底色表示距离合同执行期结束不足三个月且合同完成占比低于50%</span>
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
          @click="showTransfer">自定义设置</el-button>
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>


       <div style="margin-bottom: 10px">
        <el-tabs v-model="query.dimensionType" @tab-click="tabClick" stretch style="width: 40%">
          <el-tab-pane v-for="item in StatisticsStateArray" :key="item.id" :name="item.id + ''">
            <template slot="label">
              <el-badge :value="item.count" :max="99" class="item">
                <span style="margin: 0 10px"> {{ item.name }} </span>
              </el-badge>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>


      <div v-if="tableHaeder.length>0">
        <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
        @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
          <template slot="before">
            <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
            </el-table-column>
          </template>
          <template slot="after">
  
          </template>
        </CustomTable>
      </div>
     <div v-else>
      <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData"
      :row-class-name="tableRowClassName" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>

        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column prop="hospitalName" width="155" label="医院名称"></el-table-column>
        <el-table-column prop="no" fixed width="175" label="合同编号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="name" width="150" label="合同名称"></el-table-column>

            <el-table-column prop="supplierProductNo" v-if="query.dimensionType == 1" :key="'supplierProductNo'" label="供应商产品编码" min-width="180">
              <template slot-scope="scope">
                {{scope.row.supplierProductNo}}
              </template>
            </el-table-column>
            <el-table-column prop="productName" v-if="query.dimensionType == 1" :key="'productName'" label="产品名称" min-width="180"></el-table-column>
            <el-table-column prop="specName" v-if="query.dimensionType == 1" :key="'specName'" label="规格型号" min-width="180"></el-table-column>
        <el-table-column  v-if="query.dimensionType == 2" show-overflow-tooltip :key="'productRegistCertNo'" prop="productRegistCertNo" width="170" label="注册证号">
          <template slot-scope="scope">
            <el-button type="text" v-preventReClick @click="getCertDetails(scope.row)" class="color-blue">{{scope.row.productRegistCertNo}}</el-button>
          </template>
        </el-table-column>
        <el-table-column  v-if="query.dimensionType == 2" show-overflow-tooltip :key="'productRegistCertName'" prop="productRegistCertName" width="170" label="注册证名称"></el-table-column>
         <el-table-column v-if="query.dimensionType == 3" :key="'productCode'" prop="productCode" label="商品代码" min-width="120">
          <template slot-scope="scope">
            <el-button type="text" v-preventReClick @click="getCertDetails(scope.row)" class="color-blue">{{scope.row.productCode}}</el-button>
          </template>
         </el-table-column>
        <el-table-column  show-overflow-tooltip prop="distributionBatchName" width="170" label="集采批次"></el-table-column>
        <el-table-column label="执行期开始日期" width="120">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.startDate), "{y}-{m}-{d}") }}
          </template>
        </el-table-column>
        <el-table-column label="执行期结束日期" width="120">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.endDate), "{y}-{m}-{d}") }}
          </template>
        </el-table-column>
        <el-table-column prop="number" width="95" label="合同量"></el-table-column>
        <el-table-column prop="amount" width="95" label="合同金额"></el-table-column>
        <el-table-column prop="finishNumber" width="140" label="中选注册证采购量"></el-table-column>
        <el-table-column prop="finishAmount" width="150" label="中选注册证采购金额"></el-table-column>
        <el-table-column prop="ratio" width="130" label="合同完成量占比">
          <!-- <template slot-scope="scope">
            {{ scope.row.ratio * 100 + '%' }}
          </template> -->
        </el-table-column>
      </el-table>

    </div>

      <el-dialog title="采购明细" :visible.sync="certDialogDisable" :center="true" width="1100px" :before-close="cancel" :close-on-click-modal="false">
        <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="certPurchaseDetails" :max-height="tableHeight" style="width: 100%" stripe :header-cell-style="{ background: '#DDEBFF' }">
          <!-- <template slot="empty">
            <div class="empty-div" :style="{ height: tableHeight + 'px' }">
              <img src="../../../../assets/noData.png" width="240" height="240" />
              <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
              <div class="empty-rest" @click="reset">恢复默认</div>
            </div>
          </template> -->

          <el-table-column v-if="query.dimensionType == 2" :key="'productRegistCertNo'" show-overflow-tooltip prop="productRegistCertNo" width="170" label="注册证号"></el-table-column>
          <el-table-column v-if="query.dimensionType == 2" :key="'productRegistCertName'" show-overflow-tooltip prop="productRegistCertName" width="170" label="注册证名称"></el-table-column>
          <el-table-column v-if="query.dimensionType == 2" :key="'manufacturerName'" show-overflow-tooltip prop="manufacturerName" width="170" label="生产厂家"></el-table-column>
          <el-table-column v-if="query.dimensionType == 3" :key="'productCode'" show-overflow-tooltip prop="productCode" width="170" label="商品代码"></el-table-column>
          <el-table-column show-overflow-tooltip prop="supplierProductNo" width="150" label="供应商产品编码"></el-table-column>
          <el-table-column show-overflow-tooltip prop="productName" width="150" label="供应商产品名称"></el-table-column>
          <el-table-column show-overflow-tooltip prop="specName" width="150" label="规格型号"></el-table-column>

          <el-table-column label="执行期开始日期" width="120">
            <template slot-scope="scope">
              {{ parseTime(new Date(scope.row.startDate), "{y}-{m}-{d}") }}
            </template>
          </el-table-column>
          <el-table-column label="执行期结束日期" width="120">
            <template slot-scope="scope">
              {{ parseTime(new Date(scope.row.endDate), "{y}-{m}-{d}") }}
            </template>
          </el-table-column>
          <el-table-column  :key="'supplierName'" prop="supplierName" min-width="200" label="配送企业"></el-table-column>  
          <el-table-column prop="number" width="95" label="采购量"></el-table-column>
          <el-table-column prop="amount" width="95" label="采购金额"></el-table-column>
        </el-table>

        <div class="pagination">
          <el-pagination background layout="prev, pager, next" :page-size="detailQuery.pageSize" :current-page="detailQuery.pageIndex" :total="detailTotal" @current-change="detailChangePage">
          </el-pagination>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
        </div>
      </el-dialog>

    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import {
  GetSpdContractDetails,
  ExportSpdContractDetails,
  GetContractPurchaseDetails
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  SpdContractStateOptions,
  ApproveStatusOptions,
} from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from "@/mixin/baseList-mixin.js";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data () {
    return {
      GetDatasAction: GetSpdContractDetails,
      exportAction: ExportSpdContractDetails,
      editPath: "spd-contract-edit",
      SpdContractStateOptions: SpdContractStateOptions,
      ApproveStatusOptions: ApproveStatusOptions,
      filterOptions1:[
         {
          name: "合同编码",
          type: "input",
          code: "no",
        },
           {
          name: "合同名称",
          type: "input",
          code: "name",
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName",
        },{
          name: "规格型号",
          type: "input",
          code: "specName",
        },{
          name: "供应商产品编码",
          type: "input",
          code: "supplierProductNo",
        },
            {
          name: "集采批次",
          type: "select",
          code: "distributionBatchId",
          filterMethod: this.getDistributionBatchs,
          data: [],
        },
        {
          name: "合同执行期",
          type: "date",
          code: "start",
          startDateCode: "startContractDate",
          endDateCode: "endContractDate",
        },
        {
          name: "合同完成量占比",
          type: "numberRange1",
          startCode: 'startRatio',
          endCode: 'endRatio'
        },
      ],
      filterOptions2:[
        {
          name: "合同编码",
          type: "input",
          code: "no",
        },
           {
          name: "合同名称",
          type: "input",
          code: "name",
        },
          {
          name: "商品代码",
          type: "input",
          code: "productCode",
        },
            {
          name: "集采批次",
          type: "select",
          code: "distributionBatchId",
          filterMethod: this.getDistributionBatchs,
          data: [],
        },
        {
          name: "合同执行期",
          type: "date",
          code: "start",
          startDateCode: "startContractDate",
          endDateCode: "endContractDate",
        },
        {
          name: "合同完成量占比",
          type: "numberRange1",
          startCode: 'startRatio',
          endCode: 'endRatio'
        },
      ],
      filterOptions: [
        {
          name: "合同编码",
          type: "input",
          code: "no",
        },
           {
          name: "合同名称",
          type: "input",
          code: "name",
        },
        {
          name: "注册证号",
          type: "input",
          code: "productRegistCertNo",
        },
        {
          name: "注册证名称",
          type: "input",
          code: "productRegistCertName",
        },
        {
          name: "集采批次",
          type: "select",
          code: "distributionBatchId",
          filterMethod: this.getDistributionBatchs,
          data: [],
        },
        {
          name: "合同执行期",
          type: "date",
          code: "start",
          startDateCode: "startContractDate",
          endDateCode: "endContractDate",
        },
        {
          name: "合同完成量占比",
          type: "numberRange1",
          startCode: 'startRatio',
          endCode: 'endRatio'
        },
      ],

      certDialogDisable: false,
      contractDetail: {},
      certPurchaseDetails: [],
      allCertPurchaseDetails: [],
      detailTotal: 0,
      // 查询条件
      detailQuery: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1
      },
      StatisticsStateArray:[
        {
          id: 1,
          name: '产品维度',
          count: 0
        },
        {
          id: 2,
          name: '注册证维度',
          count: 0
        },
        {
          id: 3,
          name: '商品代码维度',
          count: 0
        },
       
      ]
    };
  },
  methods: {
    getCertDetails (row) {
      this.certDialogDisable = true
      this.detailQuery.certId = row.productRegistCertId
      this.detailQuery.contractDetailId = row.detailId
      this.detailQuery.productCode = row.productCode
      this.getCertPurchaseDetails()
    },
    cancel () {
      this.certDialogDisable = false
      this.detailQuery.certId = ''
      this.detailQuery.contractDetailId = ''
      this.certPurchaseDetails = []
      this.allCertPurchaseDetails = []
    },
    getCertPurchaseDetails () {
      GetContractPurchaseDetails(this.detailQuery)
        .then(res => {
          this.allCertPurchaseDetails = res.returnData.data;
          this.detailTotal = this.allCertPurchaseDetails ? this.allCertPurchaseDetails.length : 0;
          this.certPurchaseDetails = this.getPaginationData(
            this.allCertPurchaseDetails,
            this.detailQuery.pageIndex,
            this.detailQuery.pageSize);//res.returnData.data;
        })
    },
    detailChangePage (val) {
      console.log('detailChangePage', val)
      this.$set(this.detailQuery, "pageIndex", val);
      this.certPurchaseDetails = this.getPaginationData(this.allCertPurchaseDetails,
        this.detailQuery.pageIndex,
        this.detailQuery.pageSize)
    },
    tableRowClassName({row, rowIndex}) {
      // 获取当前日期
        let today = new Date();

        // 计算三个月后的日期
        // 获取当前日期的年份和月份
        let year = today.getFullYear();
        let month = today.getMonth(); // 0 是 1 月，11 是 12 月

        // 创建一个新的日期对象
        let futureDate = new Date(today);

        // 将月份加上三个月
        futureDate.setMonth(month + 3);

        // 获取三个月后的时间戳（以毫秒为单位）
        let timestamp = futureDate.getTime();
        
        if (new Date(row.endDate).getTime()<timestamp &&parseFloat(row.ratio.replace('%', '')).toFixed(2) <50) {
          return 'warning-row';
        }else{
          return '';
        }
      
      },
  tabClick (tab) {
      this.ids = [];
      this.multipleSelection = [];
      this.multiple = true;
      if(this.$refs.customTable){
        this.$refs.customTable.callChildMethod().clearSelection();
      }
      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      this.query.no = ''
      this.query.name = ''
      this.query.productCode = ''
      this.query.productRegistCertNo = ''
      this.query.productRegistCertName = ''
      this.query.distributionBatchId = ''
      this.query.start = ''
      this.query.startRatio = ''
      this.query.endRatio = ''
      this.query.startContractDate = ''
      this.query.endContractDate = ''

      // this.$set(this.query, 'appId', id);
      this.getData();
    },

    getPaginationData (list, pageIndex, pageSize) {
      return list.slice((pageIndex - 1) * pageSize, pageIndex * pageSize);
    },
  },
  created () {
    this.query.dimensionType = '1'
  },
  mounted () {
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-table .warning-row {
  background: rgba(227, 69, 54, 0.429);
}
/deep/.el-badge__content.is-fixed {
  top: 10px !important;
  right: 16px !important;
}
</style>
